<template>
  <footer>
    <div class="footer">
      <p>{{ $t('app.footer') }}</p>
    </div>
  </footer>
</template>

<script>
    export default {
      name: 'AppFooter',
      data() { return {}; },
    };
</script>




// WEBPACK FOOTER //
// src/layouts/app-footer.vue